<template>
  <div class="index">
    <!-- 左侧列表栏、搜索结果栏 -->
    <the-sidebar>
      <div class="sidebar-overview" v-show="sidebarStatus === 'NEARBY' || sidebarStatus === 'SUBJECT'">
        <div class="overview-header">
          <div class="overview-tab">
            <div class="tab-item"
                 :class="{ active: sidebarStatus === 'NEARBY' }"
                 @click="sidebarStatus = 'NEARBY'">附近大厅</div>
            <div class="tab-item"
                 :class="{ active: sidebarStatus === 'SUBJECT' }"
                 @click="sidebarStatus = 'SUBJECT'">全部专题</div>
          </div>
        </div>
        <el-scrollbar class="scrollbar">
          <div class="overview-body">
            <transition name="sidebar">
              <!-- 默认列表 -->
              <hall-list
                v-infinite-scroll="getHallList"
                v-loading="listLoading"
                infinite-scroll-immediate = false
                :infinite-scroll-disabled="listLoading || noMore"
                :data="handleHallList(hallList)"
                :itemCode="currentItem"
                v-show="sidebarStatus === 'NEARBY'"
                @selectHall="selectHall"
                @active="active"
                @cancel-bar="cancelHall"
                @show-nav="showNav"></hall-list>
            </transition>
            <transition name="sidebar">
              <subject-list v-show="sidebarStatus === 'SUBJECT'"
                            :data="subjectList"
                            @selectSubject="selectSubject"></subject-list>
            </transition>
          </div>
        </el-scrollbar>
      </div>
      <div class="sidebar-xcbl" v-show='sidebarStatus === "XCBL"'>
        <div class="detail-header">
          <span class="detail-back" @click="cancelproSearch('')"><i class="ri-arrow-left-s-line"></i>可通办服务大厅推荐</span>           
        </div>
        <!-- <div class="overview-header">
            <div class="overview-tab">
              <div class="tab-item"
                  :class="{ active: proSort === 'distance' }"
                  @click="prosortType('distance')">按距离推荐</div>
              <div class="tab-item"
                  :class="{ active: proSort === 'left' }"
                  @click="prosortType('left')">按流量推荐</div>
            </div>
        </div> -->
        <el-scrollbar class="scrollbar">
          <div class="overview-body">
            <transition name="sidebar">
              <hall-list
                v-infinite-scroll="getMapProject"
                v-loading="listLoading"
                infinite-scroll-immediate = false
                :infinite-scroll-disabled="listLoading || noMore"
                :data="handleHallList(prohallList)"
                @sideBarStatusChange="sidebarStatusbl"
                @selectHall="selectHall"
                @active="active"
                @cancel-bar="cancelHall"
                @show-nav="showNav"></hall-list>
            </transition>
          </div>
        </el-scrollbar>
      </div>
      <!-- 搜索结果 -->
      <div class="sidebar-detail" v-show="sidebarStatus === 'DETAIL'">
        <div class="detail-header">
          <span class="detail-back" @click="cancelSearch('')"><i class="ri-arrow-left-s-line"></i>返回</span>
          <div class="detail-type">{{ detailHeaderName }}</div>
        </div>
        <div class="detail-body">
          <el-scrollbar class="scrollbar">
            <transition name="sidebar">
              <div v-if="currentDetailList.length">
                <!-- 大厅类型使用筛选组件 -->
                <hall-filter
                  v-if="currentSubject && currentSubject.code === '1-1'"
                  @changeFilter="filterSearch"
                  :momentType="momentType"
                  :momentSort="momentSort"
                ></hall-filter>
                <!-- 列表组件除事项类型外，统一使用大厅列表组件 -->
                <!-- <div id="item-list" class="item-list"
                  v-infinite-scroll="searchHallList"
                  v-loading="listLoadingSearch"
                  infinite-scroll-immediate = false
                  :infinite-scroll-disabled="listLoadingSearch || noMoreSearch"
                  v-if="searchType && searchType === 'ITEM'">
                  <div class="item"
                    v-for="(item, index) in currentDetailList"
                    :key="index + item.id" @click.native="selectItem(item)">
                  <div class="item-title">
                      <div>{{ item.NAME }}</div>
                      <span>{{ item.SYS_ORG_NAME }}</span>
                      <span>{{ item.PC_APPLY_NAME }} </span>
                    </div>
                  <div class="btn-wrap">
                    <el-button size="mini" plain
                      @click="getGuideBasicInfo(item)">办事指南</el-button>
                    <el-button size="mini" plain>发起预约</el-button>
                  </div>
                  </div>
                </div> -->
                 <el-collapse class="item-list"
                            v-infinite-scroll="searchHallList"
                            v-loading="listLoadingSearch"
                            infinite-scroll-immediate = false
                            :infinite-scroll-disabled="listLoadingSearch || noMoreSearch"
                             v-if="searchType && searchType === 'ITEM'">
                  <el-collapse-item
                      v-for="(item, index) in currentDetailList"
                      :key="index + item.ID"
                      @click.native="checkCrossDomain(item)">
                    <template slot="title">
                      <div class="item-title">
                        <div>{{ item.NAME }}</div>
                      </div>
                    </template>
                    
                    <div class="no-hall" v-if="item.guideLoading">正在加载区划和部门信息</div>
                    <div class="no-hall" v-else>选择区划和部门查看大厅信息：</div>
                    <div class="condition-wrap">
                      <el-tooltip class="item" effect="dark" content="输入区划名称搜索" placement="top-start">
                        <el-select
                          v-model="item.region"
                          placeholder="请选择区划"
                          filterable
                          @change="changeHallRegion(item)"
                          :disabled="item.guideLoading">
                          <el-option
                            v-for="r in item.regionList"
                            :key="r.value + item.ID"
                            :label="r.label"
                            :value="r.value">
                          </el-option>
                        </el-select>
                      </el-tooltip>
                        <el-select
                        v-model="item.depart"
                        placeholder="请选择部门"
                        @change="getPriorProjectListByItemCode(item, true)"
                        :disabled="item.guideLoading">
                        <el-option
                          v-for="d in item.region ? item.departList.filter(u => item.region ? item.region == u.code : true ) : []"
                          :key="d.value + item.ID"
                          :label="d.label"
                          :value="d.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="btn-wrap" >
                      <el-button type="primary" plain
                        @click="getGuideBasicInfo(item)"
                        :loading="item.guideLoading"
                        :disabled="item.guideLoading || !currentMatter"
                      >办事指南</el-button>
                    </div>
                    <div class="btn-wrap" v-if="item.hallList.length">该事项支持“全市通办”，可任选下列大厅办理</div>
                    <div class="no-hall" v-if="item.hallLoading && !item.hallList.length">正在加载大厅数据...</div>
                    <!-- <div class="no-hall" v-if="!item.hallLoading && !item.hallList.length">暂无大厅数据</div> -->
                    <hall-list :data="item.hallList || []"
                               @selectHall="selectItemHall($event, item)"
                               @showAppointment1="showAppointment1"
                               ></hall-list>
                    <!-- <div class="view-more">
                      <span>
                        <template v-if="item.toggle === false" @click="getItemInfoByItemCode(item)">展开<i class="ri-arrow-down-s-line"></i></template>
                        <template v-else>收起<i class="ri-arrow-up-s-line"></i></template>
                      </span>
                    </div> -->
                  </el-collapse-item>
                </el-collapse>

                <hall-list v-else
                  v-infinite-scroll="searchHallList"
                  v-loading="listLoadingSearch"
                  infinite-scroll-immediate = false
                  :infinite-scroll-disabled="listLoadingSearch || noMoreSearch"
                  :data="currentDetailList"
                  @selectHall="selectHall"
                  @show-nav="showNav"></hall-list>
              </div>
              <no-data v-else v-loading="listLoadingSearch">
                <div class="tip-title">您可以：</div>
                <div class="tip-info">1.在<span @click="cancelSearch('NEARBY')">附近大厅</span>查找结果；</div>
                <div class="tip-info">2.在<span @click="cancelSearch('SUBJECT')">全部专题</span>查找结果。</div>
              </no-data>
            </transition>
          </el-scrollbar>
        </div>
      </div>
      <transition name="sidebar">
        <the-nav v-show="showSidebarNav === true"
                 :data="navigationData"
                 @start="startTrip"
                 @clear="clearTrip"
                 @cancel-nav="cancelNav"></the-nav>
      </transition>
    </the-sidebar>
    <!-- 地图主体界面 -->
    <div class="map-container">
      <the-map :data="mapData"
               ref="map"
               @selectMarker="selectMarker"
               @showNav="showNav"></the-map>
      <transition name="sidebar">
        <!-- 右侧大厅详情栏 -->
        <the-hallbar ref="hallBar"
                     v-show="currentHall"
                     :data="currentHall"
                     :itemCode="currentItem"
                     :sidebarStatus='sidebarStatus'
                     @stopLoading="hallBarStopLoading"
                     @showNav="showNav"
                     @cancel-bar="cancelHall"></the-hallbar>
      </transition>
      <!-- <transition name="sidebar">
        <the-order v-show="showAppointOrder === true"
          :data="navigationData"
          @start="startTrip"
          @clear="clearTrip"
          @cancel-nav="cancelNav"></the-order>
      </transition> -->
    <!-- 办事指南 -->
    <el-dialog
        :close-on-click-modal="false"
        modal-append-to-body
        append-to-body
        :visible.sync="showBusinessGuide"
        width="1200px">
      <BusinessGuide
      :item-data="currentMatter"
      ></BusinessGuide>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import hallMixins from "@/mixins/hallMixins";
import { mapGetters } from "vuex";
import store from "@/store";
// import Bus from '@/api/bus'
export default {
  name: "Index",
  mixins: [hallMixins],
  components: {
    TheSidebar: () => import("@comp/TheSidebar"),
    TheNav: () => import("@comp/TheNav"),
    TheHallbar: () => import("@comp/TheHallbar"),
    TheMap: () => import("@comp/TheMap"),
    SubjectList: () => import("@comp/SubjectList"),
    HallList: () => import("@comp/HallList"),
    HallFilter: () => import("@comp/HallFilter"),
    NoData: () => import("@comp/NoData"),
    BusinessGuide: () => import("@comp/BusinessGuide")
  },
  data() {
    return {
      // 侧边栏当前状态：'NEARBY'：附近大厅；'SUBJECT'：全部专题；'DETAIL'：专题/搜索列表
      sidebarStatus: "NEARBY",
      // 显示导航面板
      showSidebarNav: false,
      showBusinessGuide: false,
      // 前序状态
      prevStatus: null,
      // 导航数据
      navigationData: {},
      momentType: {},
      momentSort: {},
      // 是否可通办数据
      crossDomain: [],
    };
  },
  computed: {
    ...mapGetters(['proSort']),
  },
  methods: {
    sidebarStatusbl() {
      this.sidebarStatus = "XCBL";
    },
    
  },
  mounted() {
    this.$store.dispatch("getAppraiseLabels");
    // 调用接口获取用户信息
    let { trustticket } = this.$route.query;
    console.log("trustticket", this.$route.query);
    if (trustticket) {
      this.$store.dispatch("getUserInfo", trustticket);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.index {
  position: relative;
  width: 100%;
  height: 100%;
  ::v-deep .the-sidebar {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
  .map-container {
    position: relative;
    z-index: 3;
    margin-left: $sidebarWidth;
    height: 100%;
  }
}
.sidebar-overview {
  position: relative;
  width: 100%;
  height: 100%;
  .overview-header {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    width: 100%;
    padding: $paddingVertical $paddingHorizontal;
    background-color: #fff;
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    // backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(255, 255, 255, 0.72);
  }
  .overview-body {
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 72px;
  }
  .overview-tab {
    height: 40px;
    padding: 4px;
    background: #f5f7fa;
    border-radius: 8px;
    .tab-item {
      float: left;
      width: 50%;
      height: 32px;
      line-height: 32px;
      color: #8c9ab3;
      text-align: center;
      border-radius: 6px;
      cursor: pointer;
      transition: $transitionTime;
      &:hover {
        color: $colorTextPrimary;
      }
      &.active {
        color: $colorTextPrimary;
        background: #fff;
        box-shadow: 1px 1px 3px 0 #dde4ef;
      }
    }
  }
}
.sidebar-xcbl {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 60px;
  .detail-header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 48px;
    padding: 0 $paddingHorizontal;
    line-height: 48px;
    background: #f5f8fc;
  }
  .overview-header {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 48px;
    width: 100%;
    padding: $paddingVertical $paddingHorizontal;
    background-color: #fff;
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    // backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(255, 255, 255, 0.72);
  }
  .detail-back {
    position: relative;
    float: left;
    padding-right: 8px;
    height: 48px;
    line-height: 48px;
    cursor: pointer;
    transition: $transitionTime;
    i {
      font-size: 16px;
      vertical-align: -3px;
    }
    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      height: 12px;
      margin: auto 0;
      background-color: #999;
    }
    &:hover {
      color: $colorPrimary;
    }
  }
  .overview-body {
    position: relative;
    width: 100%;
    height: 100%;
    // padding-top: 72px;
  }
  .overview-tab {
    height: 40px;
    padding: 4px;
    background: #f5f7fa;
    border-radius: 8px;
    .tab-item {
      float: left;
      width: 50%;
      height: 32px;
      line-height: 32px;
      color: #8c9ab3;
      text-align: center;
      border-radius: 6px;
      cursor: pointer;
      transition: $transitionTime;
      &:hover {
        color: $colorTextPrimary;
      }
      &.active {
        color: $colorTextPrimary;
        background: #fff;
        box-shadow: 1px 1px 3px 0 #dde4ef;
      }
    }
  }
}
.sidebar-detail {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 48px;
  .detail-header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 48px;
    padding: 0 $paddingHorizontal;
    line-height: 48px;
    background: #f5f8fc;
  }
  .detail-back {
    position: relative;
    float: left;
    padding-right: 8px;
    height: 48px;
    line-height: 48px;
    cursor: pointer;
    transition: $transitionTime;
    i {
      font-size: 16px;
      vertical-align: -3px;
    }
    &:after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      height: 12px;
      margin: auto 0;
      background-color: #999;
    }
    &:hover {
      color: $colorPrimary;
    }
  }
  .detail-type {
    margin-left: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .detail-body {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
.tip-title {
  padding-top: 24px;
  margin-bottom: 8px;
  font-size: 16px;
}
.tip-info {
  span {
    margin: 0 4px;
    color: $colorPrimary;
    cursor: pointer;
    text-decoration: underline;
  }
}
.view-more {
  padding: 8px 0;
  text-align: center;
  span {
    cursor: pointer;
    &:hover {
      color: $colorPrimary;
    }
  }
  i {
    width: 18px;
    height: 18px;
    margin-left: 4px;
    text-align: center;
    line-height: 18px;
    color: $colorPrimary;
    background: $colorPrimaryLighten;
    vertical-align: -3px;
    border-radius: 50%;
  }
}

.item-list {
  .btn-wrap {
    padding: 0 16px 14px;

    button {
      display: block;
      width: 100%;
    }
  }
}

.condition-wrap {
  display: flex;
  padding: 0 16px 10px;

  & > * {
    &:nth-child(1) {
      width: 46%;
    }
  }
}

.no-hall {
  padding: 0 16px 10px;
  color: #999;
}
</style>
